import { getDeviceInfo, storage } from 'core';
import { Api, ws } from 'lib';
import { store } from 'store';

async function logout(navigate) {
  const deviceInfo = await getDeviceInfo();

  if (deviceInfo) {
    await Api.post('/users/logout', { deviceToken: deviceInfo.token }, 'navigator');
  }

  await storage.removeItem('token');
  ws.disconnect();
  store.dispatch({ type: 'LOGOUT' });
  navigate && navigate('/');
}

export default logout;
